var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rp-cart-button rp-button",style:({
    backgroundColor: _vm.color.primaryMain,
    color: _vm.color.primarySub,
    borderColor: _vm.color.primaryMain,
    fontFamily: _vm.globalFont
  }),on:{"click":_vm.buyNow}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.totalProductQuantity))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rp-icon"},[_c('i',{staticClass:"fa fa-lg fa-shopping-cart"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-509043e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartButton/ButtonStyle1.vue
// module id = null
// module chunks = 